(function () {
  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function initSection(root) {
    const stage = root.querySelector("[data-ba-stage]");
    const slidesWrap = root.querySelector("[data-ba-slides]");
    const slides = Array.from(root.querySelectorAll("[data-ba-slide]"));
    const prevBtn = root.querySelector("[data-ba-prev]");
    const nextBtn = root.querySelector("[data-ba-next]");
    const dotsWrap = root.querySelector("[data-ba-dots]");
    const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll("[data-ba-dot]")) : [];

    if (!slides.length) return;

    let activeIndex = slides.findIndex(s => s.classList.contains("is-active"));
    if (activeIndex < 0) activeIndex = 0;

    function setActive(i) {
      activeIndex = (i + slides.length) % slides.length;

      slides.forEach((s, idx) => {
        const isOn = idx === activeIndex;
        s.classList.toggle("is-active", isOn);
      });

      dots.forEach((d, idx) => {
        const isOn = idx === activeIndex;
        d.classList.toggle("is-active", isOn);
        d.setAttribute("aria-selected", isOn ? "true" : "false");
      });

      // reset slider position to center for new slide
      const slide = slides[activeIndex];
      const compare = slide.querySelector("[data-ba-compare]");
      const before = slide.querySelector("[data-ba-before]");
      const handle = slide.querySelector("[data-ba-handle]");
      if (compare && before && handle) {
        applyPosition(compare, before, handle, 0.5);
      }
    }

    function applyPosition(compareEl, beforeEl, handleEl, ratio) {
      const pct = clamp(ratio, 0.06, 0.94) * 100;
      beforeEl.style.width = pct + "%";
      handleEl.style.left = pct + "%";
    }

    function bindCompare(slide) {
      const compare = slide.querySelector("[data-ba-compare]");
      const before = slide.querySelector("[data-ba-before]");
      const handle = slide.querySelector("[data-ba-handle]");
      if (!compare || !before || !handle) return;

      let dragging = false;

      function updateFromClientX(clientX) {
        const rect = compare.getBoundingClientRect();
        const ratio = (clientX - rect.left) / rect.width;
        applyPosition(compare, before, handle, ratio);
      }

      function onDown(e) {
        dragging = true;
        handle.focus({ preventScroll: true });
        if (e.type === "mousedown") e.preventDefault();
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        updateFromClientX(clientX);
      }

      function onMove(e) {
        if (!dragging) return;
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        updateFromClientX(clientX);
      }

      function onUp() {
        dragging = false;
      }

      // drag handle
      handle.addEventListener("mousedown", onDown);
      window.addEventListener("mousemove", onMove);
      window.addEventListener("mouseup", onUp);

      handle.addEventListener("touchstart", onDown, { passive: true });
      window.addEventListener("touchmove", onMove, { passive: true });
      window.addEventListener("touchend", onUp);

      // allow clicking anywhere on compare to move handle
      compare.addEventListener("mousedown", onDown);
      compare.addEventListener("touchstart", onDown, { passive: true });

      // keyboard nudge
      handle.addEventListener("keydown", (e) => {
        const rect = compare.getBoundingClientRect();
        const current = parseFloat(before.style.width || "50") / 100;
        const step = 0.03;
        if (e.key === "ArrowLeft") {
          applyPosition(compare, before, handle, current - step);
          e.preventDefault();
        }
        if (e.key === "ArrowRight") {
          applyPosition(compare, before, handle, current + step);
          e.preventDefault();
        }
      });

      // init center
      applyPosition(compare, before, handle, 0.5);
    }

    slides.forEach(bindCompare);

    // nav
    prevBtn && prevBtn.addEventListener("click", () => setActive(activeIndex - 1));
    nextBtn && nextBtn.addEventListener("click", () => setActive(activeIndex + 1));

    // dots
    dots.forEach((d) => {
      d.addEventListener("click", () => {
        const idx = parseInt(d.getAttribute("data-ba-dot"), 10);
        if (!Number.isNaN(idx)) setActive(idx);
      });
    });

    // basic swipe between slides (mobile)
    let startX = null;
    slidesWrap.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    slidesWrap.addEventListener("touchend", (e) => {
      if (startX == null) return;
      const endX = e.changedTouches[0].clientX;
      const dx = endX - startX;
      startX = null;

      if (Math.abs(dx) > 60) {
        if (dx > 0) setActive(activeIndex - 1);
        else setActive(activeIndex + 1);
      }
    }, { passive: true });

    setActive(activeIndex);
  }

  function initAll() {
    document.querySelectorAll(".ba_section[data-ba-section-id]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
